// App paths linked from several places. Route definitions live in appRoutes.
export const COACH_APPLY_PATH = '/coach/apply'
export const BUSINESS_APPLY_PATH = '/business/apply'
